import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { Code } from '@nextui-org/react';

interface QuestionDroppableProps {
  id: string;
  text: string;
  draggedItem?: string;
}

const QuestionDroppable = (props: QuestionDroppableProps) => {
  const { isOver, setNodeRef } = useDroppable({
    id: props.id,
  });

  const bgColor = isOver ? 'bg-gray-200' : 'bg-transparent';

  return (
    <div className="flex w-full">
      <div className="w-3/5 pr-2 flex items-center">
        <span className="text-base font-medium">{props.text}:</span>
      </div>
      <div ref={setNodeRef} className={`w-2/5 p-2  rounded ${bgColor}`}>
        <Code className="whitespace-pre-wrap break-words font-mono text-sm ">
          {props.draggedItem || 'Drag an answer here'}
        </Code>
      </div>
    </div>
  );
};

export default QuestionDroppable;
